module.exports = __webpack_public_path__ + "img/shopee_9thb_0010.c7fc1000.png";